import { Component, inject } from '@angular/core';
import { LoaderService } from './shared/services/loader.service';
import { UtilsService } from './shared/services/utils.service';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import packageJson from '../../package.json';
import { CookieService } from 'ngx-cookie-service';
import { MatProgressBar } from '@angular/material/progress-bar';
import { RouterOutlet } from '@angular/router';
import { TourStepTemplateComponent } from 'ngx-ui-tour-md-menu';
import { AsyncPipe } from '@angular/common';
import { LoggingService } from './shared/services/logging.service';
import { IfNativeDirective } from './shared/directives/if-native.directive';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    LottieComponent,
    MatProgressBar,
    RouterOutlet,
    TourStepTemplateComponent,
    AsyncPipe,
    IfNativeDirective
  ],
})
export class AppComponent {
  loaderService = inject(LoaderService);
  private readonly utilsService = inject(UtilsService);
  private readonly cookieService = inject(CookieService);
  private readonly loggingService = inject(LoggingService);

  // Override console methods

  public currentAnimation: AnimationOptions = this.utilsService.getAnimations();

  public loadAnimation: AnimationOptions = {
    path: '/assets/loader.json',
  };

  public version: string = packageJson.version;

  constructor() {
    console.log = (message?: any, ...optionalParams: any[]) => {
      this.loggingService.debug(message, ...optionalParams);
    };

    console.debug = (message?: any, ...optionalParams: any[]) => {
      this.loggingService.debug(message, ...optionalParams);
    };

    console.info = (message?: any, ...optionalParams: any[]) => {
      this.loggingService.info(message, ...optionalParams);
    };

    console.warn = (message?: any, ...optionalParams: any[]) => {
      this.loggingService.warn(message, ...optionalParams);
    };

    console.error = (message?: any, ...optionalParams: any[]) => {
      this.loggingService.error(message, ...optionalParams);
    };

    this.utilsService.registerIcons();
    const cookie = this.cookieService.get('currentVersion');
    console.info(cookie);
    if (!cookie) {
      this.cookieService.deleteAll();
      this.cookieService.deleteAll('/');
    }
    this.cookieService.set('currentVersion', this.version, {
      expires: 365,
      path: '/',
    });
  }
}
